<template>
  <div>
    <div class="ts-border ts-border-gray-300 ts-rounded-md ts-p-4 ts-space-y-2">
      <div class="row">
        <div class="col-md-4 ts-p-1" v-for="(d, index) in model.promo_schedule_list" :key="index">
          <div class="ts-flex ts-space-x-2">
            <div class="ts-w-32">
                <div class="checkbox checkbox-css">
                  <input
										v-model="d.day_id"
                    type="checkbox"
										:id="index"
										:true-value="index+1" 
										:false-value="null"
                    @change="onCheckDay(d)"
                  />
                  <label :for="index">
                    {{ day(index+1) }}
                  </label>
                </div>
            </div>
            <div>
							<a-time-picker v-model="d.time_from" format="HH:mm" valueFormat="HH:mm" />
							<div class="validate ts-text-xs" v-if="errors.has('promo_schedule_list.' + index + '.time_from')">
								{{ errors.first('promo_schedule_list.' + index + '.time_from') }}
							</div>
						</div>
            <div>
							<a-time-picker v-model="d.time_to" format="HH:mm" valueFormat="HH:mm" />
							<div class="validate ts-text-xs" v-if="errors.has('promo_schedule_list.' + index + '.time_to')">
								{{ errors.first('promo_schedule_list.' + index + '.time_to') }}
							</div>
						</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  computed: {
    day: vm => num => {
      switch (num) {
        case 1:
          return 'Monday'
          break
        case 2:
          return 'Tuesday'
          break
        case 3:
          return 'Wednesday'
          break
        case 4:
          return 'Thursday'
          break
        case 5:
          return 'Friday'
          break
        case 6:
          return 'Saturday'
          break
        case 7:
          return 'Sunday'
          break
      }
    }
  },
  created() {
    this.model = this.value
  },
  methods:{
    onCheckDay(object){
      if(object.day_id)
      {
         object.time_from = moment().startOf('day').format('HH:mm')
         object.time_to = moment().endOf('day').format('HH:mm')
      }else {
         object.time_from = null
         object.time_to = null
      }
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>